module.exports = __webpack_public_path__ + "static/media/gitImg.9a61b820.png";